import React from 'react';

/**
 * @function Highlighter 
 * @description DOM for returning highlighted string based on query
 * 
 * @param {Object} option
 * @param {Object} option.name - options label
 * @returns {String}
 */
class Highlighter extends React.Component {
    render() {
        const { string, query, ...others } = this.props;

        const splitter = '{/*---*/}';

        /**
         * @function getQueriedString 
         * @description retrieve queried string from original option text
         * 
         * @returns {String}
         */
        const getQueriedString = () => {
            const index = string.toLowerCase().indexOf(query.toLowerCase());

            return string.slice(index, index + query.length);
        }

        const formatted = string.replace(getQueriedString(), `${splitter}${getQueriedString()}${splitter}`);

        return formatted.split(splitter)
            .map(part => {
                return {
                    text: part,
                    isHighlighted: part.toLowerCase() === query.toLowerCase()
                }
            })
            .map((part, i) => {
                let text = [];
        
                if(part.isHighlighted) {
                    text.push(
                        <strong class={others.highlightClass} key={`highlighter_index_${i}`} style={{fontWeight: 700}}>{part.text}</strong>
                    );
                } else {
                    text.push(
                        <span key={`highlighter_index_${i}`} style={{whiteSpace: "pre"}}>{part.text}</span>
                    );
                }
        
                return text;
            });
    }
}

export default Highlighter;